var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgXLogo = function SvgXLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 36,
    fill: "#F8F9FB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#x-logo_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M39.938 32.314 57.414 12h-4.141L38.098 29.639 25.978 12H12l18.327 26.673L12 59.975h4.142l16.024-18.627 12.8 18.627h13.978l-19.007-27.66m-5.672 6.594-1.857-2.656-14.775-21.134h6.36l11.924 17.055 1.857 2.657L53.275 57h-6.361z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "x-logo_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12 12h46.944v48H12z"
  })))));
};
export default SvgXLogo;